// extracted by mini-css-extract-plugin
module.exports = {"DarkTheme__textarea___bz0af":"DarkTheme__textarea___bz0af","DarkTheme__is-focused___1TP1y":"DarkTheme__is-focused___1TP1y"};